export default __webpack_public_path__ + "static/media/add-my-list-add.9c220e82.svg";